import React, {useEffect, useRef} from 'react';
import CarouselIndicators from "./carouselIndicators";
import CarouselItem from "./carouselItem";

const Carousel = ({data}) => {
    const carouselRef = useRef(null);
    useEffect(() => {
        if (carouselRef.current) {
            window.$(carouselRef.current).carousel();
        }
    },[]);
    return (
        <div ref={carouselRef} id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
            <ol className="carousel-indicators">
                {data && data.map((item, index) => <CarouselIndicators key={item.id} count={index}/>)}
            </ol>
            <div className="carousel-inner">
                {data && data.map((item, index) => <CarouselItem key={item.id} item={item} count={index}/>)}
            </div>
        </div>
    );
};

export default Carousel;
